import gsap from"gsap";

export default function initCountUps(){
    const countUps = document.querySelectorAll<HTMLElement>(".count-up");

    countUps.forEach(card => {
        const toValue = Number(card.innerHTML);
        const count = { value: (toValue < 50 ? .1 : toValue * .9) };

        gsap.set(card.querySelectorAll("span"), { opacity: 0, y: 30 + "%" });

        gsap.fromTo(count, { value: count.value }, {
            scrollTrigger: {
                trigger: card,
                start: "top bottom-=5%",
                once: true,

                onEnter: () => {
                    gsap.fromTo(card.parentElement, { opacity: 0, y: -20 + "%" }, {
                        opacity: 1,
                        y: 0,
                        duration: .8,
                        ease: "ease"
                    });
                }
            },

            value: toValue,
            duration: 1.5,
            ease: "ease-out",

            onUpdate: () => {
                card.innerText = `${Number(count.value).toFixed(((toValue % 1) === 0 ? 0 : 1))}`;
            }
        });
    });
}